import { inject, Injectable, signal } from '@angular/core';
import { useMutation } from '@globalconnect/query';
import { CombinedProjectOverviewResponse } from '../delivery-overview.entities';
import { ProjectsOverviewApiService } from './api/projects-overview-api.service';

export enum ModalStates {
  ACCEPT = 'ACCEPT',
  LOADING = 'LOADING',
  COMPLETED = 'COMPLETED',
}

@Injectable({
  providedIn: 'root',
})
export class ProjectCompletionModalService {
  private readonly apiService = inject(ProjectsOverviewApiService);
  private readonly _selectedProject = signal<
    CombinedProjectOverviewResponse | undefined
  >(undefined);
  readonly selectedProject = this._selectedProject.asReadonly();

  private readonly _isModalOpen = signal(false);
  readonly isModalOpen = this._isModalOpen.asReadonly();

  private readonly _modalState = signal<ModalStates>(ModalStates.ACCEPT);
  readonly modalState = this._modalState.asReadonly();

  private readonly _completedProject = signal<
    CombinedProjectOverviewResponse | undefined
  >(undefined);
  readonly completedProject = this._completedProject.asReadonly();

  setSelectedProject(project: CombinedProjectOverviewResponse | undefined) {
    this._selectedProject.set(project);
  }

  setIsModalOpen = (state: boolean) => {
    this._isModalOpen.set(state);
  };

  setModalState = (state: ModalStates) => {
    this._modalState.set(state);
  };

  markProjectAsComplete = (id: string) =>
    useMutation(() => this.apiService.markProjectAsComplete(id), {
      onSuccess: (completedData) => {
        this.setModalState(ModalStates.COMPLETED);
        const selectedProject = this.selectedProject();
        if (selectedProject && completedData) {
          this._completedProject.set({
            ...selectedProject,
            completedResourceResponse: completedData,
          });
        }
      },
      onError: (err) => {
        this.setModalState(ModalStates.ACCEPT);
        console.error(err);
      },
      onMutate: () => this.setModalState(ModalStates.LOADING),
    }).mutate();
}
